import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Checkbox, Divider } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { Column } from "../common/Table/Interfaces";
import { TOGGLE_ALL } from "../../constants/checkbox";
import { SAVE_BUTTON } from "../../constants/buttons";
import {
  OnChangeColumnCheckbox,
  OnSaveColumnVisibility,
} from "../../interfaces/common";

interface Props extends OnChangeColumnCheckbox, OnSaveColumnVisibility {
  items: Column[];
  className: string;
  showToggleAllButton?: boolean;
  isOpenDropDown: boolean;
}

const Overlay: React.FC<Props> = ({
  items,
  className,
  onChange,
  saveChanges,
  showToggleAllButton,
  isOpenDropDown,
}) => {
  const [hasChanges, setHasChanges] = useState(false);
  const [values, setValues] = useState<string[]>(
    items.filter((item) => item.isActive).map((item) => item.key)
  );

  useEffect(() => {
    setValues(items.filter((item) => item.isActive).map((item) => item.key));
  }, [items.length, isOpenDropDown]);

  const [indeterminate, setIndeterminate] = React.useState<boolean>(false);
  const [isCheckedAll, setCheckAll] = React.useState(false);

  const ref = useRef(false);

  useEffect(() => {
    setIndeterminate(values.length > 0 && values.length < items.length);
    setCheckAll(items.length === values.length);

    if (!ref.current) {
      ref.current = true;
      return;
    }

    setHasChanges(true);

    if (onChange) {
      onChange(values as string[]);
    }
  }, [items.length, onChange, values, values.length]);

  const onChangeHandler = useCallback(
    (checkedValues: Array<CheckboxValueType>): void => {
      setValues(checkedValues as string[]);
    },
    []
  );

  const saveChangesHandler = (): void => {
    setHasChanges(false);

    if (!saveChanges) {
      return;
    }

    saveChanges();
  };

  const onCheckAllChange = () => {
    setValues(
      values.length === items.length ? [] : items.map((item) => item.key)
    );
  };

  return (
    <div className={className}>
      {showToggleAllButton ? (
        <Checkbox
          indeterminate={indeterminate}
          onChange={onCheckAllChange}
          checked={isCheckedAll}
        >
          {TOGGLE_ALL}
        </Checkbox>
      ) : null}

      <Divider />
      <Checkbox.Group
        options={items.map((item) => ({
          label: item.title,
          value: item.key,
        }))}
        value={values}
        onChange={onChangeHandler}
      />

      <Button
        type="primary"
        className="btn--full-width"
        onClick={saveChangesHandler}
        disabled={!hasChanges}
        size="small"
      >
        {SAVE_BUTTON}
      </Button>
    </div>
  );
};

export default Overlay;
